import { useState } from "react"
import { errorToast } from "@/v2-ui/toast"
import Editor from "@/v2-backoffice-client/components/editor"
import { useUserUpdateMutation } from "@/v2-backoffice-client/user/update/user.update.mutation"

export type UserUpdateConfigurationProps = {
  userId: number | null | undefined
  configuration: unknown
}

function UserUpdateConfiguration(props: UserUpdateConfigurationProps) {
  const { userId, configuration } = props
  const [error, setError] = useState<Error | undefined>()
  const [updateUser, { loading }] = useUserUpdateMutation({
    onError: setError,
  })

  errorToast(error, {
    title: "Failed to update user",
  })

  if (!userId) return null
  return (
    <Editor
      value={JSON.stringify(configuration, null, 2)}
      isSaving={loading}
      onSave={(value) => {
        let parsed = ""
        try {
          parsed = JSON.parse(value)
        } catch (error) {
          setError(error instanceof Error ? error : new Error(String(error)))
        }

        updateUser({
          variables: {
            input: { Id: userId, Configuration: parsed },
          },
        })
      }}
    />
  )
}

export default UserUpdateConfiguration
